import React from 'react';
import { Link } from 'react-router-dom';

interface CTABarProps {
  onContactClick: () => void;
}

const CTABar: React.FC<CTABarProps> = ({ onContactClick }) => (
  <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
    <button onClick={onContactClick} className="btn btn-primary">
      Start a Conversation
    </button>
    <Link to="/quiz" className="btn btn-secondary">
      Start AI Readiness Assessment
    </Link>
  </div>
);

export default CTABar;
